import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import classNames from 'classnames';
import './TestAnalytics.scss';
import moment from 'moment';


const formatDate = (date) => {
  return moment(date).format('MM/DD');
};

class TestAnalytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOit: '',
      reportAnalytics: null,
      popupPosition: {},
      isFullscreen: false
    };
  }

  componentDidMount() {    
  }

  toggleFullscreen() {
    this.setState({
      isFullscreen: !this.state.isFullscreen
    })
  }

  render() {
    return (
      <LoadingOverlay>
        <div className="test-analytics app-content">
          {this.props.resultsMap && (
            <div className={classNames({
              'test-analytics-report': true,
              'fullscreen': this.state.isFullscreen
            })}>
              <div className="toggle-fullscreen" onClick={() => this.toggleFullscreen()}><i
                className="fa fa-arrows-alt"/></div>
              <div className="questions list">
                <div className="question-placeholder">#</div>
                {this.props.questions.map(question => (
                  <div className="question" title={question.title} key={question.id}>
                    {question.title}
                  </div>
                ))}
              </div>
              
              {this.props.tests.map(test => (
                <div className="test" key={test.id}>
                  <div className="test-header">{formatDate(test.started_at)}</div>
                    {this.props.questions.map(question => (
                      <div key={question.id}>
                        {this.props.resultsMap[`${test.id}${question.id}`]
                          ? <div className="questions">
                              {this.props.resultsMap[`${test.id}${question.id}`] == 'true' &&
                                <div className="question correct">
                                  <i className="fa fa-check" />
                                </div>
                              }
                              {this.props.resultsMap[`${test.id}${question.id}`] == 'false' &&
                                <div className="question incorrect">
                                  <i className="fa fa-minus" />
                                </div>
                              }
                            </div>
                          : <div className="questions">
                              <div className="question na">
                                N/A
                              </div>
                            </div>
                        }
                      </div>
                    ))}
                </div>
              ))}

            </div>
          )}
        </div>
      </LoadingOverlay>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}


export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestAnalytics));
